import React from 'react';

import { inclusionConfig } from '../../../configs/inclusionConfig';

import CatalogItemResultsContainer from './CatalogItemResultsContainer';

export default function AccommodationInclusionsResultsContainer() {
  return <CatalogItemResultsContainer config={inclusionConfig} />;
}
